import React from 'react'

export default () => {
  return (
    <React.Fragment>
      <div className="my-2">
        <h3 className="text-center text-lg font-semibold">Lyricify It | Created by <span> </span> 
          <a href="https://github.com/ref-bit" className="text-indigo-700">Ref-Bit</a>
        </h3>
      </div>
    </React.Fragment>
  )
}
